import React from "react";
import Button from "@mui/material/Button";

export const DefaultButton = ({ onClick, text }) => {
  return (
    <div
      className="center"
      style={{
        textDecoration: "none",
        paddingTop: 20,
        paddingBottom: 20
      }}
    >
      <Button
        onClick={onClick}
        variant="contained"
        color="primary"
        style={{ textTransform: "none", height: 40, width: 300 }}
      >
        {text}
      </Button>
    </div>
  );
};
